module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/4-998b28c86d5855682574448dc8ffd429.jpg";